import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\StoreDemandController::__invoke
* @see app/Http/Controllers/StoreDemandController.php:13
* @route '/kontakt'
*/
const StoreDemandController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreDemandController.url(options),
    method: 'post',
})

StoreDemandController.definition = {
    methods: ["post"],
    url: '/kontakt',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\StoreDemandController::__invoke
* @see app/Http/Controllers/StoreDemandController.php:13
* @route '/kontakt'
*/
StoreDemandController.url = (options?: RouteQueryOptions) => {
    return StoreDemandController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\StoreDemandController::__invoke
* @see app/Http/Controllers/StoreDemandController.php:13
* @route '/kontakt'
*/
StoreDemandController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreDemandController.url(options),
    method: 'post',
})

export default StoreDemandController